import {
  Article,
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { MediaItemCardWithActions } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActions";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { useTranslation } from "@coworker/locales";
import { getMediaItemBadges } from "@coworker/apprestructured/src/media-maintenance/helpers/getMediaItemBadges";

interface MediaItemCardLCSubItemProps {
  itemInfo: Item;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  article: Article;
  totalQuantityPieces?: number;
  shouldDisplayQuantity?: boolean;
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType: MediaItemViewType;
  stockInfo?: ItemStockInfo;
  badges4AK1?: string[];
  itemTags?: string[];
}

export const MediaItemCardLCSubItem = ({
  itemInfo,
  salesStopData,
  article,
  edsData,
  totalQuantityPieces = 0,
  shouldDisplayQuantity = true,
  itemCardRenderType = ItemCardRenderType.link,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
  stockInfo,
  badges4AK1 = [],
  itemTags = [],
}: MediaItemCardLCSubItemProps) => {
  const { t } = useTranslation();
  const itemBadges = getMediaItemBadges(
    article.productArticleId,
    [],
    t,
    false,
    salesStopData,
    undefined,
    false,
    badges4AK1,
    itemTags
  );

  return (
    <MediaItemCardWithActions
      mediaItemViewType={mediaItemViewType}
      edsData={edsData ?? null}
      item={itemInfo}
      badges={itemBadges || []}
      article={article}
      stockInfo={stockInfo}
      itemCardRenderType={itemCardRenderType}
      shouldDisplayQuantity={shouldDisplayQuantity}
      totalQuantityPieces={totalQuantityPieces}
      mediaItemType={MediaItemType.LC_SUBITEM}
      renderActions={() => null}
    />
  );
};
